import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash-es';

import { InvokeAction } from 'site-modules/shared/components/inventory/invoke-action/invoke-action';
import { INSIDER_PATHS } from 'client/site-modules/shared/constants/profile/dashboard-paths';

/**
 * Shows get price drop alerts section.
 * @param {boolean} active
 * @param {boolean} disabled
 * @param {Function} onClick
 * @param {Boolean} isAuthenticated
 * @param {Boolean} userHasEmail
 * @param {String} trackingValue
 * @returns {ReactElement}
 */
export function GetPriceDropAlerts({
  active = false,
  disabled = false,
  onClick = null,
  isAuthenticated = false,
  userHasEmail = true,
  trackingValue = '',
}) {
  const trackingId = isAuthenticated && !active ? 'vin_save_vehicle' : 'vin_sign_up_progress';
  const dataTrackingValue = isAuthenticated && !active ? trackingValue : 'email_me';
  const trackingParent = 'save-vin-price-drop-alert';
  const commonProps = {
    icon: 'icon-envelop',
    iconColor: 'text-white',
    iconClassName: 'size-16',
    iconWrapperClassName:
      'circle-icon-wrapper bg-blue-50 rounded-circle d-inline-flex align-items-center justify-content-center col-auto',
    primaryTextClassName: 'text-cool-gray-10 size-16 fw-medium ps-0_75',
    arrowClassName: 'display-lg text-primary-darker',
    classes:
      'd-flex justify-content-between align-items-center mt-1_5 rounded-12 fw-normal px-1 py-1 border-0 email-price-drop',
    withIconWrapper: true,
    textWrapperClassName: 'col px-0',
    primaryColor: '',
  };

  const renderEmailPriceDropAlertsComponent = () => (
    <InvokeAction
      {...commonProps}
      primaryText="Email me price drop alerts"
      onClick={onClick}
      dataTrackingId={trackingId}
      disabled={disabled || isNil(isAuthenticated)}
      data-tracking-value={dataTrackingValue}
    />
  );

  if (!userHasEmail) {
    return (
      <div className="get-price-drop-alerts" data-tracking-parent={trackingParent}>
        {renderEmailPriceDropAlertsComponent()}
      </div>
    );
  }

  return (
    <div className="get-price-drop-alerts" data-tracking-parent={trackingParent}>
      {active ? (
        <InvokeAction
          {...commonProps}
          primaryText="Subscribed to price drop alerts"
          href={INSIDER_PATHS.INVENTORY_PAGE}
          dataTrackingId="nav_access_my_account"
          rel="nofollow"
        />
      ) : (
        renderEmailPriceDropAlertsComponent()
      )}
    </div>
  );
}

GetPriceDropAlerts.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  userHasEmail: PropTypes.bool,
  onClick: PropTypes.func,
  trackingValue: PropTypes.string,
};
